import { z } from "zod";

export const idDocumentsSchema = z
  .object({
    national_id_number: z.string().min(1, { message: "validation.id.number_required" }),
    national_id_issue_date: z
      .date({ message: "validation.id.issue_date_required" })
      .nullable()
      .refine((d) => d instanceof Date, { message: "validation.id.issue_date_required" }),
    national_id_expiry_date: z
      .date({ message: "validation.id.expiry_date_required" })
      .nullable()
      .refine((d) => d instanceof Date, { message: "validation.id.expiry_date_required" }),
    national_id_issued_by: z.string().min(1, { message: "validation.id.issued_by_required" }),
    national_id_file: z.instanceof(File).optional().nullable(),
  })
  .superRefine((data, ctx) => {
    if (data.national_id_issue_date) {
      const endOfToday = new Date();
      endOfToday.setHours(23, 59, 59, 999);
      if (data.national_id_issue_date > endOfToday) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "validation.id.issue_date_future",
          path: ["national_id_issue_date"],
        });
      }
    }

    if (
      data.national_id_issue_date &&
      data.national_id_expiry_date &&
      data.national_id_issue_date >= data.national_id_expiry_date
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "validation.id.expiry_before_issue",
        path: ["national_id_expiry_date"],
      });
    }
  });

export type IdDocumentsFormValues = z.input<typeof idDocumentsSchema>;
